"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var icons_1 = require("../../../icons");
var style_1 = require("../../../style");
var layout_1 = require("../../layout");
var CarouselImage_1 = __importDefault(require("./CarouselImage"));
var CarouselItem_1 = __importDefault(require("./CarouselItem"));
var Dots_1 = __importDefault(require("./Dots"));
var styles_1 = require("./styles");
var Carousel = function (_a) {
    var _b = _a.activeIndex, activeIndex = _b === void 0 ? 0 : _b, _children = _a.children, onChange = _a.onChange, _c = _a.showControls, showControls = _c === void 0 ? true : _c, _d = _a.showDots, showDots = _d === void 0 ? true : _d, _e = _a.theme, carouselTheme = _e === void 0 ? 'light' : _e;
    var children = react_2.default.Children.toArray(_children);
    var theme = style_1.useTheme();
    var size = children.length;
    var styles = styles_1.getCarouselStyles(theme, carouselTheme);
    return (react_1.jsx("div", { css: styles.container },
        react_1.jsx(layout_1.Flex, { css: {
                position: 'absolute',
                left: 0,
                top: 0,
                height: '100%',
                width: "calc(100% * " + size + ")",
                transform: "translateX(" + -100 * activeIndex / size + "%)",
                transition: 'all 0.5s',
            } }, children),
        showDots && (react_1.jsx("div", { css: {
                position: 'absolute',
                bottom: 16,
                left: '50%',
                transform: 'translateX(-50%)',
            } },
            react_1.jsx(Dots_1.default, { activeIndex: activeIndex, onChange: onChange, total: size, theme: carouselTheme }))),
        showControls && (react_1.jsx(react_2.Fragment, null,
            react_1.jsx("button", { css: [
                    styles.controls,
                    {
                        left: 16,
                    },
                ], disabled: activeIndex === 0, onClick: function () {
                    onChange === null || onChange === void 0 ? void 0 : onChange(activeIndex - 1);
                } },
                react_1.jsx(icons_1.ChevronLeft, { size: 20 })),
            react_1.jsx("button", { css: [
                    styles.controls,
                    {
                        right: 16,
                    },
                ], disabled: activeIndex === size - 1, onClick: function () {
                    onChange === null || onChange === void 0 ? void 0 : onChange(activeIndex + 1);
                } },
                react_1.jsx(icons_1.ChevronRight, { size: 20 }))))));
};
exports.default = Object.assign(Carousel, {
    Image: CarouselImage_1.default,
    Item: CarouselItem_1.default,
});
